import { render, staticRenderFns } from "./VerificationPhoneCard.vue?vue&type=template&id=70dc14b3&scoped=true&"
import script from "./VerificationPhoneCard.vue?vue&type=script&lang=js&"
export * from "./VerificationPhoneCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dc14b3",
  null
  
)

export default component.exports